import DefaultCRUD from '../utils'
const resource = `/station`;

const { get, create } = DefaultCRUD(resource)

export default {
  get,
  create,
}
